"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPersonalityTemplate = exports.createDetailsTemplate = void 0;
const dantalion_core_1 = require("@kurone-kito/dantalion-core");
const article_1 = __importDefault(require("./article"));
const details_1 = require("./details");
const genius_1 = require("./genius");
const list_1 = require("./list");
const specialized_1 = require("./specialized");
/**
 * Create the Markdown only accompany resources.
 * @param source The source.
 */
const onlyAccompanying = (source, accessors) => list_1.line(details_1.detailsBase({ src: accessors.brain.getCategoryDetail() }), details_1.detailsMore({ src: accessors.brain.getByKey(source.brain) }), details_1.detailsBase({ src: accessors.communication.getCategoryDetail() }), details_1.detailsMore({
    src: accessors.communication.getByKey(source.communication),
}), details_1.detailsBase({ src: accessors.management.getCategoryDetail() }), details_1.detailsMore({ src: accessors.management.getByKey(source.management) }), details_1.detailsBase({ src: accessors.response.getCategoryDetail() }), details_1.detailsMore({ src: accessors.response.getByKey(source.response) }), details_1.detailsBase({ src: accessors.position.getCategoryDetail() }), details_1.detailsMore({ src: accessors.position.getByKey(source.position) }), specialized_1.fromMotivation(accessors.motivation, source.motivation));
/**
 * Create the Markdown from detail.
 * @param type The type of genius
 * @param source The source.
 */
const createDetailsTemplate = (type, source, accessors) => {
    const desc = accessors.getDescription();
    return list_1.line(details_1.detailsBase({ src: accessors.vector.getCategoryDetail() }), specialized_1.fromVector(desc.strategy, accessors.vector.getByKey(source.vector)), details_1.detailsBase({ src: accessors.genius.getCategoryDetail() }), genius_1.createFromGenius(desc)(accessors.genius.getByKey(type), 3), onlyAccompanying(source, accessors));
};
exports.createDetailsTemplate = createDetailsTemplate;
/**
 * Create the Markdown from the birthday.
 * @param source The source.
 * @param accessors
 */
const createPersonalityTemplate = (source, accessors) => {
    const details = dantalion_core_1.getDetail(source.inner);
    const { cc, strategy } = accessors.getDescription();
    return list_1.line(details_1.detailsBase({ src: accessors.vector.getCategoryDetail() }), specialized_1.fromVector(strategy, accessors.vector.getByKey(details.vector)), genius_1.fromGeniusForPersonality(source, accessors), specialized_1.fromLifeBase(accessors.lifeBase, source.lifeBase), specialized_1.fromPotential(accessors.potential, source.potentials), onlyAccompanying(details, accessors), article_1.default({ head: cc, body: dantalion_core_1.toCC(source), level: 2 }));
};
exports.createPersonalityTemplate = createPersonalityTemplate;
//# sourceMappingURL=template.js.map